"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PayFabricHostedForm;

var _react = _interopRequireDefault(require("react"));

var _PayFabricHostedFormModule = _interopRequireDefault(require("./PayFabricHostedForm.module.css"));

var _paymentHelpers = require("./paymentHelpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var validOrigin = /^https:\/\/www\.payfabric\.com|https:\/\/sandbox\.payfabric\.com/;

function PayFabricHostedForm(props) {
  var _validOrigin$exec;

  var hostedFormUrl = props.hostedFormUrl,
      handleSaveTransactionCompleted = props.handleSaveTransactionCompleted,
      handleTransactionCompleted = props.handleTransactionCompleted,
      handleTransactionFailed = props.handleTransactionFailed,
      handleWalletCreateCompleted = props.handleWalletCreateCompleted,
      handleWalletUpdateCompleted = props.handleWalletUpdateCompleted,
      handleFormLoaded = props.handleFormLoaded,
      handleCancel = props.handleCancel,
      handleSubmit = props.handleSubmit,
      classNames = props.classNames;
  var originIsValid = validOrigin.test(hostedFormUrl) || hostedFormUrl === ''; // Allow empty string for loading purposes

  var origin = originIsValid ? (_validOrigin$exec = validOrigin.exec(hostedFormUrl)) === null || _validOrigin$exec === void 0 ? void 0 : _validOrigin$exec[0] : '';

  _react.default.useEffect(function () {
    if (!origin) return;
    window.addEventListener('message', handlePayFabricMessage, false);
    return function () {
      window.removeEventListener('message', handlePayFabricMessage, false);
    };

    function handlePayFabricMessage(event) {
      // For best security practice, only accept event message from specified domain.
      if (event.origin !== origin) return; //docs: https://github.com/PayFabric/APIs/blob/master/PayFabric/Sections/Objects.md#transaction-response

      var objMsg = JSON.parse(event.data);

      switch (objMsg === null || objMsg === void 0 ? void 0 : objMsg.Event) {
        // The OnFormLoaded, OnCancel, and OnTransactionSubmit events are defined in our theme
        // They are not built into the PayFabric service
        case 'OnFormLoaded':
          if (handleFormLoaded instanceof Function) handleFormLoaded();
          return;

        case 'OnCancel':
          if (handleCancel instanceof Function) handleCancel();
          return;

        case 'OnTransactionSubmit':
          if (handleSubmit instanceof Function) handleSubmit();
          return;

        case 'OnSaveTransactionCompleted':
          if (handleSaveTransactionCompleted instanceof Function) handleSaveTransactionCompleted(objMsg);
          return;

        case 'OnTransactionCompleted':
          if (objMsg.RespStatus === _paymentHelpers.PayFabricStatuses.Approved && handleTransactionCompleted instanceof Function) {
            handleTransactionCompleted(objMsg);
          } else if (handleTransactionFailed instanceof Function) {
            objMsg.errorMessage = (0, _paymentHelpers.getErrorMessage)(objMsg.RespStatus);
            handleTransactionFailed(objMsg);
          }

          return;

        case 'OnWalletCreateCompleted':
          if (handleWalletCreateCompleted instanceof Function) handleWalletCreateCompleted(objMsg);
          return;

        case 'OnWalletUpdateCompleted':
          if (handleWalletUpdateCompleted instanceof Function) handleWalletUpdateCompleted(objMsg);
          return;
      }
    }
  }, [handleCancel, handleFormLoaded, handleSaveTransactionCompleted, handleSubmit, handleTransactionCompleted, handleTransactionFailed, handleWalletCreateCompleted, handleWalletUpdateCompleted, origin]);

  if (!originIsValid) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: _PayFabricHostedFormModule.default.error
    }, "Cannot display payment form because the form url is invalid");
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames instanceof Array ? [_PayFabricHostedFormModule.default.container].concat(_toConsumableArray(classNames)).join(' ') : _PayFabricHostedFormModule.default.container
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: hostedFormUrl,
    frameBorder: "0",
    title: "PayFabric hosted form",
    className: _PayFabricHostedFormModule.default.iFrame
  }));
}